<template>
  <div>
    <header class="messageHeader">
      <!--<a href="index.html" class="backlastpage"></a>-->
      <p class="headerSpan">09:20</p>
      <div class="messageTopDiv">
        <span class="messageTop">全部</span>
        <span class="messageTop">沟通中</span>
        <span class="messageTop">面试邀请</span>
        <span class="messageTop">私信</span>
        <span class="messageClear" style="color: #ffffff ">
          <span style="font-size: 1px">清除未读消息</span>
        <span><van-icon :color="color" @click="clickIcon" size="22px" name="bell" /></span>
        </span>
      </div>
    </header>
    <div style="margin-top: 70px">
      <div class="messageCenter">
        <div class="communicate">
          <img src="@/assets/img/2.jpg" alt="">
        </div>
        <div style="width: 78%;padding-left: 14px" class="">
          <div><span style="color:#639DD5">韩多多</span><span style="color:#BEBEBE;margin-left: 1rem;font-size: 12px ">十二栋</span></div>
          <div class="communicateRight">
            <span style="color:#BEBEBE "> 您好，有兴趣了解一下吗</span>
            <span style="color:#BEBEBE "> 2015</span>
          </div>
        </div>
      </div>
      <div class="messageCenter">
        <div class="communicate">
          <img src="@/assets/img/3.jpg" alt="">
        </div>
        <div style="width: 78%;padding-left: 14px" class="">
          <div><span style="color:#639DD5">韩多多</span><span style="color:#BEBEBE;margin-left: 1rem;font-size: 12px ">十二栋</span></div>
          <div class="communicateRight">
            <span style="color:#BEBEBE "> 您好，有兴趣了解一下吗</span>
            <span style="color:#BEBEBE "> 2015</span>
          </div>
        </div>
      </div>
    </div>

    <van-tabbar route v-model="active">
      <van-tabbar-item replace to="/" icon="wap-home-o">
        首页
      </van-tabbar-item>
      <van-tabbar-item replace to="/position" icon="envelop-o">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace @click="href()" icon="fire-o">
        <!--<van-icon name="fire-o" />-->
        社保
      </van-tabbar-item>
      <van-tabbar-item replace to="/firstMessage" icon="desktop-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item replace to="/" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:true
      }
    },
    methods:{

      clickIcon(event){
        console.log(event)
        this.bool=!this.bool
        console.log(this.bool)
//        if(bool){
//          this.color="FFFFFF"
//        }
//        this.color="#FFFFFF"
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  @import '../assets/css/common.css';
  @import '../assets/css/header.css';
  @import '../assets/css/footer.css';
  /*@import '../assets/css/mui.min.css';*/
  /*<link rel="stylesheet" href="css/mui.min.css">*/
  .headerSpan{
    margin-left: 1rem;
    line-height: 10px;
    color: #FFFFFF;
  }
  .messageHeader{
    width: 100%;
    background-color: #6e9bcf;
    position: fixed;
    top:0;
  }
  .messageTopDiv{
    display: flex;
    justify-content: space-around;
    margin-top: 2rem;
  }
  .messageTop{
    /*width: 15%;*/
    text-align: center;
    color: #FFFFFF;
  }
  .messageClear{
    color: #FFFFFF;
    /*width: 39%;*/
    text-align: center;
    /*text-align: center;*/
    display: flex;
    align-items: center;
    /*justify-content: center*/
  }
  .messageCenter{
    /*margin-top: 75px;*/
    display: flex;
    align-items: center;
    width: 85%;
    margin: auto;
    padding-top: 2rem;
  }
  .communicate{
    width: 50px;
    height: 50px;
    /*border-radius:100% ;*/
  }
.communicate img{
  width: 100%;
  /*width: 100%;*/
  border-radius: 100%;
}
  .communicateRight{
    display: flex;
    /*display: flex;*/
    justify-content: space-between;
    padding-top: 6px;
    font-size: 1px;
  }

</style>



// WEBPACK FOOTER //
// src/components/message.vue